import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectDiscountCode } from '@store/order/selectors';



const Discount = () => {
	const { t } = useTranslation('forms');

	const discountCode = useSelector(selectDiscountCode);

	if (!discountCode || discountCode.length === 0) return (
		<></>	
	)

	return (
		<div className='order-summary-element discount-element'>

			<h2>{t('inputLabels.discount')}</h2>

			<div className='summary-property'>
				<p>{discountCode}</p>
			</div>

		</div>
	);
};

export default Discount;